<!-- 权限列表 -->
<template>
	<div class='page_content'>
		<div class="page_content_top">
			<v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getJurisdictionList()" :showRefresh="true" :buttonFlag="false" ></v-button>
			<el-alert title="警告 : 非技术工作人员勿动 !" type="error" :closable="false" effect="dark" style="margin:10px 0;">
			</el-alert>
		</div>
		<div class="page_content_center">
			<el-table size="mini" stripe :data="dataList" :height="tableHeight" :key="$store.state.tableNum" border @selection-change="selecDataAction"
				style="width: 100%" row-key="jurId" :tree-props="{ children: 'children', hasChildren: false }"
				highlight-current-row>
				<el-table-column type="selection" width="40">
				</el-table-column>
				<el-table-column prop="jurId" label="ID">
				</el-table-column>
				<el-table-column align="center" prop="jurName" label="权限名称">
				</el-table-column>
				<el-table-column align="center" prop="jurCode" label="权限编码">
					<template slot-scope="scope">
						{{ scope.row.jurCode || '暂无编码' }}
					</template>
				</el-table-column>
				<el-table-column align="center" label="权限类型">
					<template slot-scope="scope">
						{{ $store.state.jurisdictionType[scope.row.jurStype].name }}
					</template>
				</el-table-column>
				<el-table-column align="center" prop="jurParentid" label="上级ID">
				</el-table-column>
				<el-table-column align="center" prop="jurHomepage" label="页面地址">
				</el-table-column>
                <el-table-column align="center" prop="jurSort" label="排序">
				</el-table-column>
			</el-table>
		</div>
		<!-- <div class="page_content_bottom">
      非技术人员请勿动
    </div> -->
		<!-- 数据操作窗口 -->
		<el-drawer :close-on-press-escape="true" title="我是标题" :visible.sync="dataActionBox.showStatus" :with-header="false"
			:append-to-body="true" :direction="dataActionBox.openMode" size="50%">
			<div class="demo-drawer__content data_action_form">
				<el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="formDataList">
					<v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'"
						:tabslist="formDataList" @tabs="(val) => { showTabs = val }">
						<template slot="tabs" slot-scope="scope">
							<div class="table_content_box">
								<!-- 主信息 -->
								<div v-if="scope.index == 0">
									<el-form ref="form" inline :model="sendDataInfo" label-width="150px" :rules="rules">
										<el-form-item label="权限名称" prop="jurName">
                                            <label slot="label" :style="$common.labelStyle('权限名称')"
                                                v-html="'权限名称'"></label>
											<el-input class="form_codition" v-model="sendDataInfo.jurName"></el-input>
										</el-form-item>
										<el-form-item label="操作类型">
                                            <label slot="label" :style="$common.labelStyle('操作类型')"
                                                v-html="'操作类型'"></label>
											<el-input class="form_codition" v-model="sendDataInfo.actionType" type="number"
												:maxlength="$store.state.inputLength"></el-input>
										</el-form-item>
										<el-form-item label="权限ID" prop="jurId">
                                            <label slot="label" :style="$common.labelStyle('权限ID')"
                                                v-html="'权限ID'"></label>
											<el-input class="form_codition" v-model="sendDataInfo.jurId"></el-input>
										</el-form-item>
										<el-form-item label="权限编码" prop="jurCode">
                                            <label slot="label" :style="$common.labelStyle('权限编码')"
                                                v-html="'权限编码'"></label>
											<el-input class="form_codition" v-model="sendDataInfo.jurCode"></el-input>
										</el-form-item>
										<el-form-item label="操作页面">
                                            <label slot="label" :style="$common.labelStyle('操作页面')"
                                                v-html="'操作页面'"></label>
											<el-input class="form_codition" v-model="sendDataInfo.jurHomepage"></el-input>
										</el-form-item>
										<el-form-item label="首页是否展示">
                                            <label slot="label" :style="$common.labelStyle('首页是否展示')"
                                                v-html="'首页是否展示'"></label>
											<el-radio-group class="form_codition" v-model="sendDataInfo.jurHomeshow">
												<el-radio-button :label="item.id"
													v-for="(item, i) in $store.state.jurisdictionHome" :key="i">
													{{ item.name }}
												</el-radio-button>
											</el-radio-group>
										</el-form-item>
										<el-form-item label="图标">
                                            <label slot="label" :style="$common.labelStyle('图标')"
                                                v-html="'图标'"></label>
											<el-input class="form_codition" v-model="sendDataInfo.jurImg"></el-input>
										</el-form-item>

										<el-form-item label="权限归属">
                                            <label slot="label" :style="$common.labelStyle('权限归属')"
                                                v-html="'权限归属'"></label>
											<el-cascader class="form_codition" ref="parentidCascader"
												v-model="selectDataPath" @change="selectPath" :options="allDataList"
												:props="{ checkStrictly: true, expandTrigger: 'hover' }" clearable>
												<template slot-scope="{ node, data }">
													<span>{{ data.label }}</span>
													<span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
												</template>
											</el-cascader>
										</el-form-item>
										<el-form-item label="类型">
                                            <label slot="label" :style="$common.labelStyle('类型')"
                                                v-html="'类型'"></label>
											<el-select class="form_codition" v-model="sendDataInfo.jurStype" placeholder="请选择"
												disabled="disabled">
												<el-option v-for="item in $store.state.jurisdictionType" :key="item.id"
													:label="item.name" :value="item.id">
												</el-option>
											</el-select>
										</el-form-item>
										<el-form-item>

										</el-form-item>
									</el-form>
								</div>

							</div>
						</template>
					</v-tabs>
				</el-card>
				<div class="foots">
					<el-button v-if="dataActionBox.actionType == 2 && $common.checkIsPrint()" type="primary"
						@click="showPrintPlan">打印</el-button>
					<el-button type="primary" @click="initActionBox" v-if="dataActionBox.actionType != 2">取消</el-button>
					<el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType == 0">保存</el-button>
					<el-button type="primary" @click="sendDataAction()" v-if="dataActionBox.actionType == 1">保存</el-button>
					<!-- <el-button type="primary" v-if="dataActionBox.actionType==3" @click="submitData()">提交供货商</el-button> -->
				</div>
			</div>

		</el-drawer>
        <menu-sort ref="menuSort"></menu-sort>
	</div>
</template>

<script>
import menuSort from '@/components/menuSort.vue';
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
	//import引入的组件需要注入到对象中才能使用
	components: {menuSort},
	data() {
		var _this = this;
		//这里存放数据
		return {
            tableHeight:0,
			formDataList: [],
			showTabs: '新增',
			dataActionBox: {
				showStatus: false,
				openMode: "ltr" || "rtl",
				boxTitle: "新增权限" || "编辑权限",
				actionType: 0, // 0新增，1修改
			},
			buttonList: [],
			dataList: [],
			selectedDataList: [],

			allDataList: [],
			selectDataPath: -1,
			sendDataInfo: {
				jurId: _this.$common.createCode(),
				actionType: 0,
				jurCode: "",
				jurHomepage: "",
				jurHomeshow: 0,
				jurImg: "",
				jurName: "",
				jurParentid: 0,
				jurStype: 0,
                jurSort:0,
			},
			rules: {
				jurName: [{
					required: true,
					message: "请输入权限名称",
					trigger: "blur"
				},],
				jurId: [{
					required: true,
					message: "请输入权限ID",
					trigger: "blur"
				}],
				jurCode: [{
					required: true,
					message: "请输入权限编码",
					trigger: "blur"
				},],
			},
            dataNode:[],
		};
	},
	//监听属性 类似于data概念
	computed: {},
	//监控data中的数据变化
	watch: {
		"sendDataInfo.jurName": {
			handler: function (newValue, oldValue) {
				this.sendDataInfo.jurCode =
					this.$common.createPinyinCode(newValue,this.sendDataInfo.jurCode);
			},
			deep: true,
		},
	},
	//方法集合
	methods: {
		initActionBox() {
			this.sendDataInfo.jurId = this.$common.createCode();
			this.sendDataInfo.actionType = 0;
			this.sendDataInfo.jurCode = "";
			this.sendDataInfo.jurHomepage = "";
			this.sendDataInfo.jurParentid = 0;
			this.selectDataPath = -1;
			this.sendDataInfo.jurHomeshow = 0;
			this.sendDataInfo.jurImg = "";
			this.sendDataInfo.jurName = "";
			this.sendDataInfo.jurStype = 0;
			this.dataActionBox.actionType = 0;
			this.dataActionBox.showStatus = false;
		},
		openActionBox(cate) {
			this.initActionBox();
			if (cate == 0) {
				this.dataActionBox.boxTitle = "新增权限";
				this.dataActionBox.openMode = "ltr";
				this.formDataList = [
					{
						jciName: "新增",
						jurconfigform: [],
					}
				]
			} else {
				if (this.getDataDateils() == false) {
					return false;
				}
				this.getJurisdictionList();
				this.dataActionBox.boxTitle = "编辑权限";
				this.dataActionBox.openMode = "ltr";
				this.formDataList = [
					{
						jciName: "编辑",
						jurconfigform: [],
					}
				]
			}
			this.dataActionBox.actionType = cate;
			this.dataActionBox.showStatus = true;
		},
		// 获取数据详情
		getDataDateils() {
			if (this.selectedDataList.length < 1) {
				this.$message({
					message: "请先选择您要修改的数据条目",
					type: "error",
				});
				return false;
			}

			if (this.selectedDataList.length > 1) {
				this.$message({
					message: "编辑信息只能选择一条数据，请勿多选",
					type: "error",
				});
				return false;
			}
			var dataInfo = this.selectedDataList[0];
			this.sendDataInfo.jurId = dataInfo.jurId;
			this.sendDataInfo.actionType = dataInfo.actionType;
			this.sendDataInfo.jurCode = dataInfo.jurCode;
			this.sendDataInfo.jurHomepage = dataInfo.jurHomepage;
			this.sendDataInfo.jurParentid = dataInfo.jurParentid;
			this.selectDataPath =
				dataInfo.jurParentid == 0 ? -1 : dataInfo.jurParentid;
			this.sendDataInfo.jurHomeshow = dataInfo.jurHomeshow;
			this.sendDataInfo.jurImg = dataInfo.jurImg;
			this.sendDataInfo.jurName = dataInfo.jurName;
			this.sendDataInfo.jurStype = dataInfo.jurStype;
			this.sendDataInfo.jurSort = dataInfo.jurSort;

			return true;
		},
		selectPath() {
			var newData = this.$refs.parentidCascader.getCheckedNodes(true);
			if (newData[0] != null) {
				if (this.selectDataPath == -1) {
					this.sendDataInfo.jurStype = 0;
					this.sendDataInfo.jurParentid = 0;
				} else {
					this.sendDataInfo.jurParentid = newData[0].value;
					this.sendDataInfo.jurStype = newData[0].data.jurStype + 1;
				}
			} else {
				this.sendDataInfo.jurStype = 0;
				this.sendDataInfo.jurParentid = 0;
			}
		},

		// 发送数据
		async sendDataAction() {
			if (this.sendDataInfo.jurId == "") {
				this.$message({
					message: "请填写ID",
					type: "error",
				});
				return false;
			}
			if (this.sendDataInfo.jurName == "") {
				this.$message({
					message: "请填写名称",
					type: "error",
				});
				return false;
			}
			if (this.sendDataInfo.jurCode == "") {
				this.$message({
					message: "请填写编码",
					type: "error",
				});
				return false;
			}

			if (this.dataActionBox.actionType == 0) {
				var responseData = await this.$http.addJurisdictionList(
					this.sendDataInfo
				);
			} else {
				var responseData = await this.$http.setJurisdictionList(
					this.sendDataInfo
				);
			}
			if (responseData.status == 200) {
				this.$message({
					message: "操作成功",
					type: "success",
				});
				this.initActionBox();
				this.getJurisdictionList();
			} else {
				this.$message({
					message: responseData.message,
					type: "error",
				});
			}
		},
		selecDataAction(data) {
			this.selectedDataList = data;
		},
		// 动作集合
		actionSet(actionData) {
            console.log(actionData.actionType);

			switch (actionData.actionType) {
				case 0:
					this.openActionBox(actionData.actionType);
					break;
				case 1:
					this.openActionBox(actionData.actionType);
					break;
                    case 3:
					this.$refs['menuSort'].openBox(this.dataNode)
					break;
			}
		},

		async getButtonList() {
			this.buttonList = await this.$common.getActionButton();
		},
		// 获取权限
		async getJurisdictionList() {
			let responseData = await this.$http.getJurisdictionList({
				jurType: 0
			}) //权限类型权限类型0.erp1.协同
			if (responseData.status == 200) {
				this.dataList = this.handleJurisdiction(responseData.result);
				this.dataNode = this.handleJurisdiction1(responseData.result);
				var initArr = [{
					value: -1,
					label: "功能模块",
					jurParentid: 0,
					children: []
				},];
				initArr[0].children = this.dataList;
				this.allDataList = this.dataList;
			} else {
				this.$message({
					message: responseData.message,
					type: "error",
				});
			}
		},

		// 权限处理
		handleJurisdiction(data, id = 0, lev = 0) {
			var son = [];
			data.forEach((value, keys) => {
				if (value["jurParentid"] == id) {
					if (value["jurId"] == this.sendDataInfo.jurId) {
						value["disabled"] = true;
					}
					value["value"] = value["jurId"];
					value["label"] = value["jurName"];
					value["lev"] = lev;
					if (value["jurStype"] >= 3) {
						value["disabled"] = true;
					}
					var list = this.handleJurisdiction(data, value["jurId"], lev + 1);
					if (list.length >= 1) {
						value["children"] = this.handleJurisdiction(
							data,
							value["jurId"],
							lev + 1
						);
					}

					son.push(value);
				}
			});
			return son;
		},
        // 权限处理
		handleJurisdiction1(data, id = 0, lev = 0) {
			var son = [];
			data.forEach((value, keys) => {
				if (value["jurParentid"] == id) {
					if (value["jurId"] == this.sendDataInfo.jurId) {
						value["disabled"] = true;
					}
					value["value"] = value["jurId"];
					value["label"] = value["jurName"];
					value["lev"] = lev;
					if (value["jurStype"] >= 3) {
						value["disabled"] = true;
					}
					var list = this.handleJurisdiction1(data, value["jurId"], lev + 1);
					if (list.length >= 1) {
                        if (value["jurStype"]==2) {
                            value["children"]=undefined
                        }else{
                            value["children"] = this.handleJurisdiction1(
							data,
							value["jurId"],
							lev + 1
						);
                        }
						
					}

					son.push(value);
				}
			});
			return son;
		},
	},
	//生命周期 - 创建完成（可以访问当前this实例）
	created() {
		this.getJurisdictionList();
		this.getButtonList();
	},
	//生命周期 - 挂载完成（可以访问DOM元素）
	mounted() {
 },
	beforeCreate() { }, //生命周期 - 创建之前
	beforeMount() { }, //生命周期 - 挂载之前
	beforeUpdate() { }, //生命周期 - 更新之前
	updated() {this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
	beforeDestroy() { }, //生命周期 - 销毁之前
	destroyed() { }, //生命周期 - 销毁完成
	activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped></style>